import { render } from "./Setor.vue?vue&type=template&id=6918dd49&scoped=true"
import script from "./Setor.vue?vue&type=script&lang=js"
export * from "./Setor.vue?vue&type=script&lang=js"

import "./Setor.vue?vue&type=style&index=0&id=6918dd49&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6918dd49"]])

export default __exports__